export default "__VITE_ASSET__DvIcD$LK__"